/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * CREATED — the version came into being. CORRECTED — changed in place, the fields listed. STATUS_CHANGED — put in force or retired, as the field status, with the approval of the source wording the same decision gave, as the field translationStatus. MEDIA_ADDED and MEDIA_REMOVED — a picture or film added to or taken out of a draft. CLASSIFICATION_CHANGED — category, source, tags or positions of the question changed. REVIEW_CHANGED — the question was marked for review, or the mark taken off. These two are listed under the question rather than a version.
 * @export
 * @enum {string}
 */

export const HistoryEventKindDto = {
    Created: 'CREATED',
    Corrected: 'CORRECTED',
    StatusChanged: 'STATUS_CHANGED',
    MediaAdded: 'MEDIA_ADDED',
    MediaRemoved: 'MEDIA_REMOVED',
    ClassificationChanged: 'CLASSIFICATION_CHANGED',
    ReviewChanged: 'REVIEW_CHANGED'
} as const;

export type HistoryEventKindDto = typeof HistoryEventKindDto[keyof typeof HistoryEventKindDto];



